'use client';
import React from 'react';
import { styled } from 'styled-components';
import Header from '../atoms/Header';
import nthLogo from '../../../public/images/logo-s.svg';
import Image from 'next/image';
import { RxCaretRight } from 'react-icons/rx';
import Link from 'next/link';
import { useSession } from 'next-auth/react';
import ContentText from '../atoms/ContentText';
import { MdOutlineOpenInNew } from 'react-icons/md';
import { BREAKPOINT_PC, BREAKPOINT_SP } from '@/util/const';
import Accordion from '../molecules/Accordion';

const menuList = {
  shopping: [
    { label: '商品一覧', link: '/product', isLogin: false },
    { label: '購入履歴', link: '/mypage/orders', isLogin: true },
    { label: '定期便契約', link: '/mypage/subscriptions', isLogin: true },
  ],
  newsEvent: [
    { label: 'お知らせ・キャンペーン', link: '/news', isLogin: false },
    // { label: 'イベント', link: '/events', isLogin: false },
  ],
  support: [
    { label: 'ライブラリ', link: '/library', isLogin: false },
    // { label: 'FAQ', link: '/faq', isLogin: false },
    {
      label: 'E-Learning',
      link: `${process.env.NEXT_PUBLIC_ELEARNING_URL || '/'}`,
      isLogin: true,
      outside: true,
      hideFromRegularUser: true,
    },
  ],
  business: [
    {
      label: 'コミッション・実績',
      link: '/mypage/commission/dashboard',
      isLogin: true,
      hideFromRegularUser: true,
    },
    {
      label: '組織図',
      link: '/mypage/group/condition',
      isLogin: true,
      hideFromRegularUser: true,
    },
    { label: 'サロン一覧', link: '/salons', isLogin: false },
    {
      label: '掲示板',
      link: '/forum',
      isLogin: true,
    },
  ],
  others: [
    { label: '会社概要', link: '/about-us' },
    {
      label: 'コーポレートサイト',
      link: 'https://www.queens-henna.com/',
      outside: true,
    },
    { label: 'プライバシーポリシー', link: '/privacy-policy' },
    { label: '特定商取引法に基づく表記', link: '/notation' },
    {
      label: 'パートナー規程集',
      link: '/agent-terms',
      isLogin: true,
      hideFromRegularUser: true,
    },
  ],
};

const SiteFooter: React.FC = () => {
  const { data: session } = useSession();
  const isLogin = !!session?.user;
  return (
    <Container>
      <div className="footer-contents">
        <div className="footer-content-shoping pc">
          <div className="footer-content-header">
            <Header type="h-footer" className="fontWeight600">
              SHOPPING
            </Header>
            <ContentText type="note-m">お買い物</ContentText>
          </div>

          {menuList.shopping.map((elm) => {
            if (!isLogin && elm.isLogin == true) return null;
            return (
              <React.Fragment key={elm.label}>
                <Link href={elm.link} className="contents-node" key={elm.label}>
                  <span>{elm.label}</span>
                  <RxCaretRight size={20} />
                </Link>
                <hr />
              </React.Fragment>
            );
          })}
        </div>
        <Accordion
          title={
            <>
              <Header type="h-footer">SHOPPING</Header>
              <ContentText type="note-m">お買い物</ContentText>
            </>
          }
          className="accordion sp"
        >
          {menuList.shopping.map((elm) => {
            if (!isLogin && elm.isLogin == true) return null;
            return (
              <React.Fragment key={elm.label}>
                <Link href={elm.link} className="contents-node" key={elm.label}>
                  <span>{elm.label}</span>
                </Link>
                <hr />
              </React.Fragment>
            );
          })}
        </Accordion>
        <div className="footer-content-news_event pc">
          <div className="footer-content-header">
            <Header type="h-footer" className="fontWeight600">
              NEWS&EVENT
            </Header>
            <ContentText type="note-m">お知らせ・イベント</ContentText>
          </div>
          {menuList.newsEvent.map((elm) => {
            if (!isLogin && elm.isLogin == true) return null;
            return (
              <React.Fragment key={elm.label}>
                <Link href={elm.link} className="contents-node" key={elm.label}>
                  <span>{elm.label}</span>
                  <RxCaretRight size={20} />
                </Link>
                <hr />
              </React.Fragment>
            );
          })}
        </div>
        <Accordion
          title={
            <>
              <Header type="h-footer">NEWS&EVENT</Header>
              <ContentText type="note-m">お知らせ・イベント</ContentText>
            </>
          }
          className="accordion sp"
        >
          {menuList.newsEvent.map((elm) => {
            if (!isLogin && elm.isLogin == true) return null;
            return (
              <React.Fragment key={elm.label}>
                <Link href={elm.link} className="contents-node" key={elm.label}>
                  <span>{elm.label}</span>
                </Link>
                <hr />
              </React.Fragment>
            );
          })}
        </Accordion>
        <div className="footer-content-support pc">
          <div className="footer-content-header pc">
            <Header type="h-footer" className="fontWeight600">
              SUPPORT
            </Header>
            <ContentText type="note-m">サポート</ContentText>
          </div>
          {menuList.support.map((elm, i) => {
            if (
              (!isLogin && elm.isLogin == true) || //ログインしていない もしくは
              (session?.user.isAgent == false && //エージェントではなくて
                elm.hideFromRegularUser == true && //非表示で
                session?.user.contact?.agent_application_status__c !=
                  '勉強中' && //勉強中でもないし
                session?.user.contact?.agent_application_status__c !=
                  '合格済み' && //合格済みでもないし
                session?.user.contact?.agent_application_status__c !=
                  '署名送信待ち' && //書類送信待ちでもないし
                session?.user.contact?.agent_application_status__c !=
                  '署名中' && //署名中でもないし
                session?.user.contact?.agent_application_status__c !=
                  '登録完了') //登録完了でもないし
            )
              return null;
            return (
              <React.Fragment key={elm.label}>
                <Link href={elm.link} className="contents-node" key={elm.label}>
                  <span>{elm.label}</span>
                  {elm.outside ? (
                    <MdOutlineOpenInNew size={20} />
                  ) : (
                    <RxCaretRight size={20} />
                  )}
                </Link>
                <hr />
              </React.Fragment>
            );
          })}
        </div>
        <Accordion
          title={
            <>
              <Header type="h-footer">SUPPORT</Header>
              <ContentText type="note-m">サポート</ContentText>
            </>
          }
          className="accordion sp"
        >
          {menuList.support.map((elm, i) => {
            if (
              (!isLogin && elm.isLogin == true) ||
              (session?.user.isAgent == false &&
                elm.hideFromRegularUser == true)
            )
              return null;
            return (
              <React.Fragment key={elm.label}>
                <Link href={elm.link} className="contents-node" key={elm.label}>
                  <span>{elm.label}</span>
                </Link>
                <hr />
              </React.Fragment>
            );
          })}
        </Accordion>
        <div className="footer-content-business pc">
          <div className="footer-content-header">
            <Header type="h-footer" className="fontWeight600">
              BUSINESS
            </Header>
            <ContentText type="note-m">ビジネス</ContentText>
          </div>
          {menuList.business.map((elm) => {
            if (
              (!isLogin && elm.isLogin == true) ||
              (session?.user.isAgent == false &&
                elm.hideFromRegularUser == true)
            )
              return null;
            return (
              <React.Fragment key={elm.label}>
                <Link href={elm.link} className="contents-node" key={elm.label}>
                  <span>{elm.label}</span>
                  <RxCaretRight size={20} />
                </Link>
                <hr />
              </React.Fragment>
            );
          })}
        </div>
        <Accordion
          title={
            <>
              <Header type="h-footer">BUSINESS</Header>
              <ContentText type="note-m">ビジネス</ContentText>
            </>
          }
          className="accordion sp"
        >
          {menuList.business.map((elm, i) => {
            if (
              (!isLogin && elm.isLogin == true) ||
              (session?.user.isAgent == false &&
                elm.hideFromRegularUser == true)
            )
              return null;
            return (
              <React.Fragment key={elm.label}>
                <Link href={elm.link} className="contents-node" key={elm.label}>
                  <span>{elm.label}</span>
                </Link>
                <hr />
              </React.Fragment>
            );
          })}
        </Accordion>
      </div>
      <div className="footer-logo">
        <div>
          <Image src={nthLogo} width={128} height={122} alt="nth-logo"></Image>
        </div>
        <div className="footer-copy_rights">
          © 2014 NTH CO.,LTD All Rights Reserved
        </div>
      </div>
      <div className="paddingtop8 pc">
        {menuList.others
          .filter((elm) => !(elm.hideFromRegularUser && !isLogin))
          .map((elm, index, filteredList) => {
            return (
              <div key={elm.label}>
                <Link
                  href={elm.link}
                  className="footer-bottom"
                  target={elm.outside ? '_blank' : ''}
                >
                  <span>{elm.label}</span>
                </Link>
                {index < filteredList.length - 1 && (
                  <span className="rightborder"></span>
                )}
              </div>
            );
          })}
      </div>
      <div className="paddingtop8-sp sp">
        <div>
          {menuList.others.slice(0, 3).map((elm) => {
            return (
              <div key={elm.label}>
                <Link
                  href={elm.link}
                  className="footer-bottom"
                  target={elm.outside ? '_blank' : ''}
                >
                  <span>{elm.label}</span>
                </Link>
                <span className="rightborder"></span>
              </div>
            );
          })}
        </div>
        <div>
          {menuList.others.slice(3).map((elm, index) => {
            if (elm.hideFromRegularUser && !isLogin) return null;
            return (
              <div key={elm.label}>
                <Link
                  href={elm.link}
                  className="footer-bottom"
                  target={elm.outside ? '_blank' : ''}
                >
                  <span>{elm.label}</span>
                </Link>
                {index < menuList.others.slice(3).length - 1 && (
                  <span className="rightborder"></span>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </Container>
  );
};

export default SiteFooter;

const Container = styled.section`
  margin-top: 64px;
  margin-bottom: 16px;
  width: 100%;
  /* min-width: 720px; */
  display: flex;
  align-items: center;
  flex-direction: column;
  gap: 16px;
  @media (max-width: ${BREAKPOINT_SP}) {
    .pc {
      display: none !important;
    }
    padding-bottom: 60px;
  }
  @media (min-width: ${BREAKPOINT_PC}) {
    .sp {
      display: none !important;
    }
  }
  .footer-logo {
    padding-top: 16px;
    gap: 8px;
    display: flex;
    flex-direction: column;
    align-items: center;
  }
  .paddingtop8 {
    display: flex;
    flex-direction: row;
    padding-top: 8px;
    gap: 8px;
    .footer-bottom {
      &:hover {
        color: var(--node-todo, #d5d2d0);
        text-decoration: underline;
      }
    }
    .rightborder {
      padding-left: 8px;
      border-right: 1px solid var(--border-lightgray-300, #d4d4d8);
    }
  }
  .paddingtop8-sp {
    div {
      display: flex;
      flex-direction: row;
      justify-content: center;
      gap: 8px;
      text-decoration: underline;
      font-size: 12px;
      font-weight: 400;
      line-height: 20.4px;
      letter-spacing: 0.02em;
      text-align: left;
      .rightborder {
        border-right: 1px solid var(--border-lightgray-300, #d4d4d8);
      }
      :nth-last-child(1) .rightborder {
        display: none;
      }
    }
  }
  .paddingtop8-sp.hidden {
    display: none;
  }
  .footer-contents {
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    max-width: 1140px;
    width: 100%;
    gap: 8px;
    padding: 0 16px;
    box-sizing: border-box;

    @media (max-width: ${BREAKPOINT_SP}) {
      gap: 0;
    }
    @media (min-width: ${BREAKPOINT_PC}) {
      > div {
        max-width: 250px;
        flex: 1 1 auto;
        @media (max-width: 991px) {
          padding: 0 16px;
          max-width: calc(50% - 36px);
          width: 100%;
        }
      }
    }
    .contents-node {
      display: flex;
      align-items: center;
      justify-content: space-between;
      cursor: pointer;
      padding: 16px 8px;
      line-height: 1.75;
      font-weight: 400;
      &:hover {
        background-color: var(--bg-tertiary-gray-100, #f4f4f5);
      }
    }
  }
  .footer-content-header {
    padding-bottom: 8px;
    border-bottom: 1px solid var(--color-dull-green, #b5c7c3);
    .fontWeight600 {
      font-weight: 600;
    }
  }
  .accordion {
    padding: 0;
    width: 100%;
    & > :nth-child(1) {
      background: white;
      padding: 16px 8px;
    }
    & > .open {
      padding-top: 0;
      hr:last-child {
        display: none;
      }
    }
    .contents-node {
      padding-left: 16px;
    }
  }
  .accordion.open > :nth-child(1) {
    background: var(--bg-tertiary-gray-100, #f4f4f5);
  }

  .footer-copy_rights {
    color: var(--node-process);
    text-align: center;
  }
  hr {
    margin: 0;
  }
  a {
    text-decoration: none;
    color: unset;
  }
`;
